import React, { useState } from 'react';

interface LoginScreenProps {
  loading: boolean;
  onSubmit: (email: string, pass: string) => void;
  onSignup: () => void;
}

export const LoginScreen: React.FC<LoginScreenProps> = ({ loading, onSubmit, onSignup }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(email, password);
  };

  return (
    <div className="pwa-auth-container">
      <h1 className="pwa-auth-title">LOGIN</h1>
      <p className="pwa-auth-subtitle">Enter your credentials to access the console</p>

      <form onSubmit={handleSubmit}>
        <div className="pwa-auth-field">
          <label className="pwa-auth-label">EMAIL OR PHONE</label>
          <input
            type="text"
            className="pwa-auth-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter email or phone number"
            autoCapitalize="none"
            required
          />
        </div>

        <div className="pwa-auth-field">
          <label className="pwa-auth-label">PASSWORD</label>
          <input
            type="password"
            className="pwa-auth-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            autoCapitalize="none"
            required
          />
        </div>

        <button type="submit" disabled={loading} className="pwa-primary-btn">
          {loading ? 'SIGNING IN...' : 'SIGN IN'}
        </button>

        <button type="button" onClick={onSignup} className="pwa-secondary-btn">
          CREATE ACCOUNT
        </button>
      </form>
    </div>
  );
};
